<div class="row my-row">

    <aside class="col-md-3 my-col" id="sticky-sidebar">
        <app-folders [activeFolderID]="activeFolder?.id"></app-folders>
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">

        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

        <div class="row my-row pt-5 pb-3">
            <div class="col-xl my-col">
                <h1 *ngIf="activeFolder?.type == 'sending' && !activeFolder?.parent?.id">{{ 'MESSAGES.FOLDER-SENDING' | translate }}</h1>
                <h1 *ngIf="activeFolder?.type == 'trash' && !activeFolder?.parent?.id">{{ 'MESSAGES.FOLDER-TRASH' | translate }}</h1>
                <h1 *ngIf="activeFolder?.type == 'draft' && !activeFolder?.parent?.id">{{ 'MESSAGES.FOLDER-DRAFT' | translate }}</h1>
                <h1 *ngIf="activeFolder?.parent?.id">{{activeFolder?.title}}</h1>
            </div>
        </div>

        <!-- Boutons d'action-->
        <div class="row my-row">
            <div class="col-lg-6 my-col order-sm-last">
                <mat-form-field class="w-50">
                    <input matInput #search (keyup)="applyFilter(search.value)" placeholder="{{ 'MESSAGES.SEARCH' | translate }}">
                </mat-form-field>
            </div>
        </div>

        <div class="row my-row pb-2" style="width: 82%; position: relative">
            <div class="col">
                <button *ngIf="activeFolder?.type == 'trash'" type="button" class="btn btn-primary" (click)="restore()"
                  [disabled]="selection.selected.length <= 0">
                  {{ "BUTTONS.RECOVERY-MESSAGE" | translate }}
                </button>
                <button type="button" class="btn btn-danger" *ngIf="activeFolder?.type != 'trash'" (click)="delete()"
                  [disabled]="selection.selected.length <= 0">
                  {{ "BUTTONS.SEND-MESSAGE-TRASH" | translate }}
                </button>
                <button type="button" class="btn btn-primary ml-1" *ngIf="activeFolder?.type == 'sending'" (click)="replayMessages()"
                  [disabled]="selection.selected.length <= 0">
                  {{ "BUTTONS.REPLAY-MESSAGE" | translate }}
                </button>
            </div>

            <div class="col" *ngIf="activeFolder && activeFolder?.type != 'trash'">
                <div class="input-group">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-primary" (click)="changeFolder(folderTo.value)"
                          [disabled]="selection.selected.length <= 0">
                          {{ "BUTTONS.MOVE" | translate }}
                        </button>
                    </div>
                    <select class="form-control" #folderTo>
                        <option disabled selected value [ngValue]="null">{{ "MESSAGES.FOLDER-SELECT" | translate }}</option>
                        <option *ngIf="activeFolder.parent.id" [value]="activeFolder.parent.id">{{activeFolder.parent.title}}</option>
                        <ng-container *ngFor="let folder of activeFolder.children">
                            <option *ngIf="activeFolder.type == folder.type && activeFolder.id != folder.id" [value]="folder.id">
                                {{folder.title}}
                            </option>
                        </ng-container>
                        <ng-container *ngFor="let brother of activeFolder.parent.children">
                            <option [value]="brother.id">
                                {{brother.title}}
                            </option>
                        </ng-container>
                    </select>
                </div>
            </div>
        </div>

        <div *ngIf="messages" class="table-container mat-elevation-z8">
            <div class="example-table-container">
                <table mat-table id="messages" class="exemple-table" [dataSource]="messages" matSort (matSortChange)="sortData($event)">

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                          <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()">
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)"
                                        [aria-label]="checkboxLabel(row)">
                          </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container *ngIf="activeFolder.type != 'receive'" matColumnDef="recipient">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-4 text-primary">
                            <h6>{{ "MESSAGES.LIST.SIGNATORIES" | translate }}</h6>
                        </th>
                        <td mat-cell *matCellDef="let message" class="truncate-cell pl-4" style="width: 30%" data-toggle="tootip" data-placement="top" title="{{message.messages.recipient}}">
                            <p [ngClass]="{'font-weight-bold' : message.open == 0}">{{message.messages.recipient}}</p>
                        </td>
                    </ng-container>

                    <ng-container *ngIf="activeFolder.type == 'receive'" matColumnDef="recipient">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-4 text-primary">
                            <h6>{{ "MESSAGES.LIST.SENDER" | translate }}</h6>
                        </th>
                        <td mat-cell *matCellDef="let message" class="truncate-cell pl-4" style="width: 30%" data-toggle="tootip" data-placement="top" title="{{message.messages.sender}}">
                            <p [ngClass]="{'font-weight-bold' : message.open == 0}">{{message.messages.sender}}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="objet">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-primary"><h6>{{ "MESSAGES.LIST.SUBJECT" | translate }}</h6></th>
                        <td mat-cell *matCellDef="let message" class="truncate-cell px-1" style="width: 20%" data-toggle="tootip" data-placement="top" title="{{message.messages.objet}}">
                            <p [ngClass]="{'font-weight-bold' : message.open == 0}">{{message.messages.objet}}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-primary"><h6>{{ "MESSAGES.LIST.DATE" | translate }}</h6></th>
                        <td mat-cell *matCellDef="let message" class="truncate-cell px-1" style="width: 20%" data-toggle="tootip" data-placement="top" title="{{message.messages.date_envoi}}">
                            <p [ngClass]="{'font-weight-bold' : message.open == 0}">{{message.messages.date_envoi}}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="attachments">
                        <th mat-header-cell *matHeaderCellDef class="text-primary"><h6>{{ "MESSAGES.LIST.ATTACHMENTS" | translate }}</h6></th>
                        <td mat-cell *matCellDef="let message" style="text-align: center; width: 10%">
                            <i class="bi bi-paperclip" *ngIf="message.messages.attachmentSize > 0"></i>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="open">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-primary"><h6>{{ "MESSAGES.LIST.OPEN" | translate }}</h6></th>
                        <td mat-cell *matCellDef="let message" style="text-align: center; width: 7%">

                            <i data-toggle="tooltip" title="Aucun destinataire n'a ouvert votre message"
                              class="text-danger check-sent bi bi-circle" style="color: #f44336" *ngIf="message.open === 0"></i>

                            <i data-toggle="tooltip" title="Tous les destinataires ont ouvert votre message"
                               class="text-success check-received bi bi-check2" style="color: #157347" *ngIf="message.open === 1"></i>

                            <i data-toggle="tooltip" title="Une partie des destinataires a ouvert votre message"
                               class="check-read bi bi-check2-circle" style="color: orange" *ngIf="message.open === 2"></i>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center text-primary"><h6>{{ "MESSAGES.LIST.ACTION" | translate }}</h6></th>
                        <td mat-cell *matCellDef="let message" style="text-align: center; width: 10%">
                            <button type="button" class="btn btn btn-primary" *ngIf="activeFolder?.type == 'sending'"
                                    data-toggle="tootip" data-placement="top" title="Renvoyer le message"
                                    (click)="$event.stopPropagation();replayMessage(message)">
                                <em class="bi bi-arrow-clockwise"></em>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                        (click)="open(row);selection.toggle(row)"
                        [ngClass]="{alternate : row.state == 1}">
                    </tr>

                </table>
            </div>
            <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
    </div>
</div>
